module.exports = __webpack_public_path__ + "static/media/oberflex-ako-2560x1440.7bdd1c36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-ako-2560x1440.jpg
// module id = 971
// module chunks = 37